import React, { useState } from 'react';
import styles from './ExperienceCard.module.css';
import { ItemFields } from '../../types';

type Props = {
  fields: ItemFields;
};

const ExperienceCard = ({ fields }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={styles.mainContainer}>
      <img
        src={fields.logo?.fields.file.url}
        alt={fields.logo?.fields.title}
        className={styles.logoImg}
      />

      <a
        className={styles.companyName}
        href={fields.companyLink}
        target="_blank"
        rel="noreferrer"
      >
        <span>{fields.companyName}</span>

        <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none">
          <path
            fill="#fff"
            d="M14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41421L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L17.5858 5H14ZM5 7C4.44772 7 4 7.44772 4 8V19C4 19.5523 4.44772 20 5 20H16C16.5523 20 17 19.5523 17 19V14.4375C17 13.8852 17.4477 13.4375 18 13.4375C18.5523 13.4375 19 13.8852 19 14.4375V19C19 20.6569 17.6569 22 16 22H5C3.34315 22 2 20.6569 2 19V8C2 6.34315 3.34315 5 5 5H9.5625C10.1148 5 10.5625 5.44772 10.5625 6C10.5625 6.55228 10.1148 7 9.5625 7H5Z"
          />
        </svg>
      </a>

      <div className={styles.timeAtRoleBullet}>
        <p className={styles.timeAtRole}>{fields.dateWorked}</p>
      </div>

      <p className={styles.roleText}>{fields.role}</p>

      <ul
        className={`${styles.descBullets} ${isExpanded ? styles.expanded : ''}`}
      >
        {fields.descriptionBullets?.map((desc) => (
          <li className={styles.descItem} key={desc}>
            {desc}
          </li>
        ))}
      </ul>

      <button
        className={styles.expandBtn}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? 'Read less' : 'Read more'}{' '}
        <svg
          height="12px"
          width="12px"
          viewBox="0 0 185 185"
          className={`${styles.expandChevron} ${
            isExpanded ? styles.flipped : ''
          }`}
        >
          <path d="M51.707,185.343c-2.741,0-5.493-1.044-7.593-3.149c-4.194-4.194-4.194-10.981,0-15.175    l74.352-74.347L44.114,18.32c-4.194-4.194-4.194-10.987,0-15.175c4.194-4.194,10.987-4.194,15.18,0l81.934,81.934    c4.194,4.194,4.194,10.987,0,15.175l-81.934,81.939C57.201,184.293,54.454,185.343,51.707,185.343z" />
        </svg>
      </button>
    </div>
  );
};

export default ExperienceCard;
